import type {
  Scalars,
  UpdateCustomDatasourceMutation,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import { UpdateCustomDatasourceDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export interface UpdateCustomDatasourceInput {
  Id: string;
  Title: string;
  Datasources: Scalars['jsonb']['input'];
  Fields: Scalars['jsonb']['input'];
  Filters: Scalars['jsonb']['input'];
}

export const useUpdateCustomDatasource = createMutationHook({
  name: 'updateCustomDatasource',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.customDatasource.update.mutationOptions({ onSuccess }),
  mapInput: (input: UpdateCustomDatasourceInput) => input,
  invalidate: (trpc) => [
    trpc.frontend.customDatasource.customDatasources.queryKey(),
    trpc.frontend.customDatasource.customDatasourceById.queryKey(),
  ],
  mapResponse: (result: { Id: string }): UpdateCustomDatasourceMutation => ({
    update_custom_datasource_by_pk: {
      __typename: 'custom_datasource',
      Id: result.Id,
    },
  }),
  graphqlDocument: UpdateCustomDatasourceDocument,
  // evict the two custom_datasource query families so the cache-first
  // `useGetCustomDatasourceById` read refetches after a save. Without this the
  // edit form re-reads a stale cache on in-app navigation and the just-saved
  // filters/fields appear reverted (RSP-6650). Mirrors the delete hook and the
  // tRPC branch's invalidateQueries.
  graphqlVariables: (input: UpdateCustomDatasourceInput) => ({
    Id: input.Id,
    Data: {
      Title: input.Title,
      Datasources: input.Datasources,
      Fields: input.Fields,
      Filters: input.Filters,
    },
  }),
  evictFields: ['custom_datasource', 'custom_datasource_by_pk'],
});
